import { DataTypeColumn } from '../../Common/commonColumnHelpers'
import {
  ConvenienceChain,
  GooglePlaceChainBase,
} from 'models/google_place_chain'
import { getGooglePlaceBaseColumns } from '../GooglePlaceBase/GooglePlaceBaseColumnsInfo'

export const CONVENIENCE_COLUMNS = getGooglePlaceBaseColumns(
  'Convenience'
) satisfies Partial<
  Record<keyof GooglePlaceChainBase | keyof ConvenienceChain, DataTypeColumn>
>
